module.exports = __webpack_public_path__ + "img/undraw_visual_data_b1wx.6bf84f4e.svg";